import React from 'react';
import { PseudoStates, PageTitle, useFetch } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import InsuranceCarriersForm from '~/components/InsuranceCarrier/Form';

const InsuranceCarriersDetails = () => {
  const { insuranceCarrierId } = useParams();
  const [status, data] = useFetch(`admin/insurance-carrier/${insuranceCarrierId}`, { instance: 'p' });

  return status === 'success' ? (
    <>
      <PageTitle>{data.attributes.carrierName}</PageTitle>

      <InsuranceCarriersForm data={data} />
    </>
  ) : (
    <PseudoStates status={status} />
  );
};

export default InsuranceCarriersDetails;
